// extracted by mini-css-extract-plugin
export default {"menu":"gB3Z4+DDG9jcZ1am41V9UA=="};